module.exports = __webpack_public_path__ + "img/iq.0e3abff7.svg";